import React from 'react';
import DynamicFortuneResult from '../components/fortune/DynamicFortuneResult';

const DynamicFortuneResultPage = () => {
  return <DynamicFortuneResult />;
};

export default DynamicFortuneResultPage;